/*
document.addEventListener('_changeVariant', function(event) {
  //console.log('Variant change')
});
*/

/*
document.addEventListener('cartItems', function(event) {
  //console.log('Cart has been updated')
});
*/

// BK8 Outfitters - Default Availability Filter to In Stock on Collection Pages
(function() {
  if (window.location.pathname.indexOf('/collections/') === 0) {
      var url = new URL(window.location.href);
          if (!url.searchParams.has('filter.v.availability')) {
                url.searchParams.set('filter.v.availability', '1');
                      window.location.replace(url.toString());
                          }
                            }
                            })();